import React from 'react';
import { Link } from 'react-router-dom';
import './EEcontent.css';

const EEcontent = () => {
    return (
        <div className="ee-container">
            <div className="Page-Main_Dec">
                <h1 className="Page-title_LowerCase">Energy Efficiency</h1>
                <nav className="ee-breadcrumb" style={{ margin: '4px 0 12px 0', fontSize: '14px', color: '#555', textAlign: 'left' }}>
                    <Link to="/" style={{ color: '#333', textDecoration: 'underline' }}>Home</Link>
                    <span style={{ color: '#777', margin: '0 6px' }}>&gt;</span>
                    <span>Energy Efficiency</span>
                </nav>
                <p className="EE-pg-subtitle">KEEP YOUR HOME WARMER IN THE WINTER AND COOLER IN THE SUMMER</p>
            </div>

            <div className="ee-full-image">
                {/* Replace with your actual image path */}
                <img src="/Assets/EEImages/energy-efficiency.webp" alt="Energy efficient windows" />
            </div>

            <div className="ee-SecSubtitle">
                <p >Callistus window blinds help conserve energy in the following important ways.</p>
            </div>

            <div className="ee-features">
                {/* Feature 1 - Insulation */}
                <div className="ee-feature-row">
                    <div className="ee-feature-image">
                        {/* Replace with your actual image path */}
                        <img src="/Assets/EEImages/Insulation.webp" alt="Insulation" />
                    </div>
                    <div className="ee-feature-text">
                        <h4>Insulation</h4>
                        <p>
                            In winters, the indoor heating escapes to the outdoors through your windows while in the summers, the outside heat flows in through the same windows. With window treatment products that provide insulation, you can reduce energy consumption, save on heating and cooling costs, and create a more comfortable atmosphere.
                        </p>
                    </div>
                </div>

                {/* Feature 2 - Solar Heat Control */}
                <div className="ee-feature-row">
                    <div className="ee-feature-image">
                        {/* Replace with your actual image path */}
                        <img src="/Assets/EEImages/3.webp" alt="Solar Heat Control" />
                    </div>
                    <div className="ee-feature-text">
                        <h4>Solar Heat Control</h4>
                        <p>
                            The warmth provided by the sun, its solar energy, maybe desirable during the winter to help heat up your space, but in summers, it can make a room overly hot and uncomfortable—driving up air conditioning costs. Many products of Callistus Window Blinds help control solar heat by allowing it into your home in the winter and minimizing the amount that comes in during the summer.
                        </p>
                    </div>
                </div>

                {/* Feature 3 - Daylighting */}
                <div className="ee-feature-row">
                    <div className="ee-feature-image">
                        {/* Replace with your actual image path */}
                        <img src="/Assets/EEImages/4-5.webp" alt="Daylighting" />
                    </div>
                    <div className="ee-feature-text">
                        <h4>Daylighting</h4>
                        <p>
                            Daylighting is the practice of lighting rooms with natural light rather than artificial light. By drawing natural light into space, many of our window treatment products reduce the need for other types of lighting, thereby reducing your energy use and costs.
                        </p>
                    </div>
                </div>

                {/* Feature 4 - UV Protection */}
                <div className="ee-feature-row">
                    <div className="ee-feature-image Lt-row-img">
                        {/* Replace with your actual image path */}
                        <img src="/Assets/EEImages/icon_08-e1590943687782.png" alt="UV Protection" />
                    </div>
                    <div className="ee-feature-text">
                        <h4>UV Protection</h4>
                        <p>
                            Callistus Window Blinds are specially manufactured to provide UV protection. We have Blinds that not only control heat and maintain the temperature of the space but also prevent the harmful UV rays that damages and create hindrances to good health.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EEcontent;